<template>
    <div v-if="show">
        <input id="path-input" v-if="mode==='create'" ref="image" type="file" @change="onBankLogoChange($event)" class="form-control">
        <div v-if="mode!=='edit'" class="input-group">
          <div id="bank-icon">
          <img :src="bank"  class="img-fluid"  style="width:50px;height:50px;"/>
          </div>
          <button id="submit-image" v-if="mode!=='view'" @click="btnClicked"  class="btn btn-primary">ثبت</button>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import EventBus from "../_framework/bus.js";
import Utils from "../_framework/utils/Utils";
export default {
  name: "table-row-image",
  props: {
    header: "",
    row: "",
    mode: "",
    headerKey: ""
  },
  //  ["header", "row", "mode", "headerKey"],
  data() {
    return {
      show: true,
      bank:""
    };
  },
  methods: {
    btnClicked() {

      if (this.$refs.image.files.length > 0) {

        let formData = new FormData();
        formData.append("file", this.$refs.image.files[0]);

        axios
          .post("/files", formData, {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          })
          .then(response => {
            console.log(response.data);
            this.logo = response.data.data;
            this.$emit("dataChanged", this.headerKey, response.data.data);
          })
          .catch(() => {
            Utils.handleErrorWithNotification(
              "آپلود عکس ممکن نیست.",
              this.$noty
            );
          });
      } else {

        // this.sendCreateRequest();
      }

    },
    refresh() {
      this.show = false;
      setTimeout(() => {
        this.show = true;
      }, 50);
    },
    onBankLogoChange(e) {
      let files = e.target.files;
      let app = this;
      if (files && files[0]) {
        for (let item of files) {
          let extension = item.name.slice((item.name.lastIndexOf(".") - 1 >>> 0) + 2);
          if (extension === "jpg" || extension === "JPG" ||
            extension === "png" || extension === "PNG" ||
            extension === "JPEG" || extension === "jpeg") {
            let reader = new FileReader();
            reader.onload = function(e) {
             // $("#bankLogo").attr("src", e.target.result);
              app.bank = e.target.result;
            };
            reader.readAsDataURL(item);
          } else {
            alert("لطفا فایل عکس بارگذاری کنید");
          }
        }
      }
    },
  },
  mounted() {
    EventBus.$on("onResetRowMode", () => {
      this.show = false;
      setTimeout(() => {
        this.show = true;
      }, 1000);
    });

  },
  watch: {},
  computed: {
    logo() {
      if (this.row) {
        return this.row.logo;

      } else {
        return "";
      }
    }
  }
};
</script>

<style scoped>
#submit-image {
  width: 50px;
  height: 50px;
  padding: 0;
  border-radius: 0;
  border-top-left-radius: 1rem;
  border-bottom-left-radius: 1rem;
}
#path-input {
  height: 50px;
  width: 70%;
  border-radius: 0;
  border-top-right-radius: 1rem;
  border-bottom-right-radius: 1rem;
}
#bank-icon {
  width: 50px;
  height: 50px;
  background-color: white !important;
  border-radius: 0.5rem;
}
</style>
